import { Route } from 'react-router-dom';
import { RequireAuth } from '../../../common/SharedComponents';
import { EstimatorPage } from '@apply/estimator';

export default function EstimatorRoutes() {
    return (
        <Route
            path='/estimator'
            element={
                <RequireAuth>
                    <div className='est-outer-admin'>
                        <EstimatorPage showFullResults={true} />
                    </div>
                </RequireAuth>
            }
        />
    );
}
